(function($, window, document, s, undefined){

  // signifies if billing details and shipping details should be the same in
  // the cart checkout form.
  var billingInfoIsShippingInfo = true;


  // AJAX ADD TO CART

  var initAjaxAddToCart = function initAjaxAddToCart() {
    $('.add-to-cart-form')
      .on('ajax:success', function ajaxAddToCartResponse(e, data) {
        var cssClass = data.success ? 'success' : 'error';
        var $submitBtn = $(e.target).find('[type="submit"]');

        s.showAndHideNotification(data.html, cssClass);

        // fetch the updated cart info
        if (data.success) {
          $.get(s.cart.itemCountUrl, function ajaxCartInfoResponse(data){
            $('#site-header').find('.basket .item-count').html(data.item_count);
          });

          s.statefulButtonChange($submitBtn, 'success');
        } else {
          s.statefulButtonChange($submitBtn, 'error');
        }
      })
      .on('ajax:error', function ajaxAddToCartSuccess(e, html) {

        s.showAndHideNotification(
          'Το προϊόν δεν προστέθηκε επιτυχώς στο καλάθι σας.');

        s.statefulButtonChange($(e.target).find('[type="submit"]'), 'error');
      })
      .on('submit', function ajaxAddToCartSubmit(e){
        s.showLoadingSpinner($(e.target).find('[type="submit"]')[0], 'white');
      });
  };

  // CART UPDATE


  var initDeleteButton = function initDeleteButton() {
    $('.delete').on('click', function(e){
      e.preventDefault();
      $(e.target)
        .siblings().first()
        .children('[name^="form-"][name$="-DELETE"]')
          .prop('checked', true)
        .end()
        .closest('tr').hide()
        .closest('form').submit();
    });
  };

  var initContinueShoppingButton = function initContinueShoppingButton(){
    $('.nav-history-back').on('click', function(e){
      e.preventDefault();
      window.history.back();
    });
  };


  // CART CHECKOUT


  var initAffix = function initAffix() {
    $('.synopsis').affix({
      offset: {
        top: $('.titles').outerHeight(true) + $('.short-nav').outerHeight(true) - 20,
        bottom: $('#site-footer').outerHeight(true)
      }
    });
  };


  var initReceiptOrInvoiceToggle = function initReceiptOrInvoiceToggle() {
    if ($('#id_needs_invoice_1').prop('checked')) {
      var height = 41;  // the height of the heading contained in the form.

      $('#company-info')
        .removeClass('collapsed-y')
        .children('.form-group')
          .each(function(){
            height += $(this).outerHeight(true);
          })
        .end()
        .css('height', height + 'px');
    }

    s.$doc.on('change', '[name="needs_invoice"]', function (e){

      if (e.target.value === '0') {
        $('#company-info').addClass('collapsed-y');
      } else {
        $('#company-info').removeClass('collapsed-y');
      }
    });
  };


  var copyBillingFormToAddressForm = function copyBillingFormToAddressForm() {
    $('.billing-fields-wrapper')
      .find('input, textarea, select')
      .not('[type="hidden"]')
      .each(function (){
        var $this = $(this);
        var name = s.checkoutForm.billing_re.exec($this.attr('id'));
        var id;

        if (!name) return;

        id = '#id_' +s.checkoutForm.shippingPrefix + '-' + name[1];
        $(id).val($this.val());
      });
  };


  var initCheckToCloneFormsOnSubmit = function initCheckToCloneFormsOnSubmit() {
    s.$doc.on('submit', '#checkout-form', function(e){
      if (billingInfoIsShippingInfo) {
        e.preventDefault();
        copyBillingFormToAddressForm();
        e.target.submit();
      }
    });
  };


  var initShippingInfoFormToggle = function initShippingInfoFormToggle() {
    // Check if there are any errors in the hidden fields of the shipping
    // address form and if yes show the fields and check the appropriate radio.
    if ($('.shipping-fields-wrapper').find('.with_errors').length > 0) {
      $('.shipping-fields-wrapper').removeClass('collapsed-y');
      $('.shipping-info-toggle[value="newDetails"]').prop('checked', true);
    }

    s.$doc.on('change', '.shipping-info-toggle', function (e){
      if (e.target.value === 'sameDetails') {
        $('.shipping-fields-wrapper').addClass('collapsed-y');
        if (!billingInfoIsShippingInfo) {
            billingInfoIsShippingInfo = true;
        }
      } else {
        $('.shipping-fields-wrapper').removeClass('collapsed-y');
        if (billingInfoIsShippingInfo) {
            billingInfoIsShippingInfo = false;
        }
      }
    });
  };

  /**
  * Disables credit card payment method.
  */
  // var disableCreditCardTransactions = function disableCreditCardTransactions() {
  //   $('#id_payment_method_1').prop('checked', 'true');
  //   $('#id_payment_method_0')
  //     .attr('disabled', 'disabled')
  //     .parent()
  //       .addClass('disabled')
  //       .css('opacity', 0.5);
  // };


  /**
  * Disables pay_on_delivery payment method if cart has ebooks.
  */
  var checkIfCartHasEbooks = function checkIfCartHasEbooks() {
    if ($('#cart-has-ebooks').length) {
      $('#payment-method')
        .find('#id_payment_method_0')
          .prop('checked', 'true')
        .end()
        .find('#id_payment_method_1')
          .attr('disabled', 'disabled')
          .parent()
            .addClass('disabled')
            .css('opacity', 0.5)
          .end()
        .end()
        .find('.message')
          .html(
            'Η μέθοδος πληρωμής με αντικαταβολή δεν είναι διαθέσιμη γιατί ' +
            'έχετε ebooks στο καλάθι σας.');
    }
  };

  /**
  * Hides the quantity input for ebooks. It does not make sense and it raises
  * a ValidationError on the backend.
  * TODO: This is not called yet. Check the README.
  */
  var removeQuantityButtonsForEbooks = function removeQuantityButtonsForEbooks(){
    $('#cart-form').find('.title').find('.ebook').each(function(){
      $(this).closest('td').next('td').next('td').find('.quantity').remove();
    });
  };


  var checkForCartPages = function checkForCartPages() {
    if (s.bodyId === 'body-cart-update') {
      initDeleteButton();
      initContinueShoppingButton();
      // removeQuantityButtonsForEbooks();
    } else if (s.bodyId === 'body-cart-checkout') {
      initAffix();
      initReceiptOrInvoiceToggle();
      initShippingInfoFormToggle();
      initCheckToCloneFormsOnSubmit();
      // TODO: Enable this call.
      // checkIfCartHasEbooks();
    } else if (s.bodyId === 'body-cart-checkout-preview') {
      initAffix();
    }
  };

  s.callOnReady(initAjaxAddToCart);
  s.callOnReady(checkForCartPages);

})(jQuery, this, this.document, window.s);
